import React from "react";

const Java_Comments = () => {
  return (
    <div>
      <h1>Java Comments</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Comments in Java.</p>
    </div>
  );
};

export default Java_Comments;
